import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { ThemeContext } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-100 dark:bg-gray-900 text-gray-600 dark:text-gray-400 px-4 md:px-10 pt-16 pb-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

        {/* Kolom 1: Logo dan Deskripsi */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <Logo isDark={isDarkMode} className="h-9 mb-4" />
          <p className="text-sm leading-relaxed max-w-xs">
            {t('footer.description')}
          </p>
        </div>

        {/* Kolom 2: Navigasi */}
        <div className="text-center md:text-left">
          <h4 className="text-base font-semibold text-gray-800 dark:text-white mb-3">{t('footer.navigation')}</h4>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/" className="hover:text-primaryAccent transition-colors">
                {t('footer.links.home')}
              </Link>
            </li>
            <li>
              <Link to="/download" className="hover:text-primaryAccent transition-colors">
                {t('footer.links.download')}
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="hover:text-primaryAccent transition-colors">
                {t('footer.links.privacy')}
              </Link>
            </li>
          </ul>
        </div>

        {/* Kolom 3: Kontak */}
        <div className="text-center md:text-left">
          <h4 className="text-base font-semibold text-gray-800 dark:text-white mb-3">{t('footer.contact')}</h4>
          <ul className="space-y-1 text-sm">
            <li>{t('footer.email')}: pilari.apps@gmail.com</li>
            <li>{t('footer.phone')}: +62 853-1791-4092</li>
          </ul>
        </div>

        {/* Kolom 4: Sosial Media */}
        <div className="text-center md:text-left">
          <h4 className="text-base font-semibold text-gray-800 dark:text-white mb-3">{t('footer.social')}</h4>
          <div className="flex justify-center md:justify-start gap-4 flex-wrap">
            <a
              href="https://www.instagram.com/pilari.official"
              className="hover:text-primaryAccent transition-colors text-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-12 text-xs text-gray-500 dark:text-gray-500">
        © {new Date().getFullYear()} Pilari. {t('footer.rights')}
      </div>
    </footer>
  );
};

export default Footer;
